<template>
	<div id="feature" ref="feature">
		<div class="landing-red main-headline light-text content-maintext">
			Features
		</div>
		<div id="list-desktop" class="feature-list">
			<div class="feature-element" v-for="feature in featureData" :key="feature.id">
				<div v-if="feature.displayVariant=='A'">
					<FeatureVariantOne :feature="feature" :baseUrl="baseUrl"/>
				</div>
				<div v-if="feature.displayVariant=='B'">
					<FeatureVariantTwo :feature="feature" :baseUrl="baseUrl"/>
				</div>
				<div v-if="feature.displayVariant=='C'">
					<FeatureVariantThree :feature="feature" :baseUrl="baseUrl" style="background-color: inherit"/>
				</div>
				<div v-if="feature.displayVariant=='D'">
					<FeatureVariantFour :feature="feature" :baseUrl="baseUrl"/>
				</div>
				<div v-if="feature.displayVariant=='E'">
					<FeatureVariantFive :feature="feature" :baseUrl="baseUrl"/>
				</div>
			</div>
		</div>
		<div id="list-mobile" class="feature-list">
			<div class="feature-element" v-for="feature in featureData" :key="feature.id">
				<FeatureVariantMobile :feature="feature" :baseUrl="baseUrl"/>
			</div>
		</div>
	</div>
</template>

<script>

import FeatureVariantOne from './feature-variants/Feature-Variant-1.vue';
import FeatureVariantTwo from './feature-variants/Feature-Variant-2.vue';
import FeatureVariantThree from './feature-variants/Feature-Variant-3.vue';
import FeatureVariantFour from './feature-variants/Feature-Variant-4.vue';
import FeatureVariantFive from './feature-variants/Feature-Variant-5.vue';
import FeatureVariantMobile from './feature-variants/Feature-Variant-Mobile.vue';

import JsonProvider from '../../../services/DataService.js';
import {configData} from '../../../services/DataService.js';

	export default {
		Name: 'FeatureMainContainer',
		components: {
			FeatureVariantOne,
			FeatureVariantTwo,
			FeatureVariantThree,
			FeatureVariantFour,
			FeatureVariantFive,
			FeatureVariantMobile
			},
		methods: {
			getImages: function (images) {
				return images.reverse();
			}
		},
		data: function() {
			return {
				
			featureData: [],
			
			baseUrl: String,
			}
		},

		created: async function() {
			var jsonGetter = new JsonProvider();
			this.baseUrl = configData.baseUrl.data.baseUrl;
			this.featureData = await jsonGetter.fetchJsonObject('features', true);
		}
	}
</script>

<style>

	.image-wrapper {
		margin-top: 2em;
	}

	.feature-headline {
		width: 100%;
		font-size: 25px;
		margin-top: 1em;
		margin-bottom: 1em;
	}

	.feature-desc-short {
		margin-bottom: 1em;
	}

	.feature-container {
		max-width: 1500px;
		margin: auto;
	}

	.feature-element:nth-child(even) {
		background-color: white;
	}

	.feature-element > * {
		background-color: inherit;
	}

	.images-container {
		display: inline-block;
		align-items: center;
		max-width: 100%;
	}
	
	.stacking-wrapper:nth-child(n+2) > .feature-image {
		margin-top: -100%;
	}

	.feature-image {
		max-height:400px;
		width: auto;
		z-index: 1000;
		position: relative;
		max-width: 97%;
		}

	img {
		width: auto;
	}

	@media (max-width: 767px) {
		.images-container {
			max-width: 100%;
		}

		.feature-container {
			max-width: 90%;
		}
		
		#list-desktop {
			display: none;
		}
	}

	@media (min-width: 768px) {
		#list-mobile {
			display: none;
		}
	}

</style>
<style scoped>
	.main-headline {
		background-color: white;
		padding-bottom: 1em;
	}

	.feature-element {
		padding-bottom: 150px;
	}

	@media (max-width: 767px) {
		.feature-element {
		padding-bottom: 80px;
		}
	}
	
</style>
